import type { ReactNode } from 'react';

import styles from './MenuItem.module.css';

/** The `<ul>` around `MenuItem` rows; `separated` draws a rule above the row (e.g. Delete). */
export function MenuList({ children }: { children: ReactNode }) {
  return <ul className={styles.list}>{children}</ul>;
}

export function MenuRow({
  children,
  separated = false,
}: {
  children: ReactNode;
  separated?: boolean;
}) {
  return <li className={separated ? styles.separated : undefined}>{children}</li>;
}
